import React from 'react';
import { Grid, Typography, Paper, makeStyles } from '@material-ui/core';
import ActivityIndicator from '../../ActivityIndicator';
import { freightsAwaitingDriver } from '../../../hooks/freights/useGetFreightStatistics';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(2),
    marginTop: theme.spacing(2),
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)',
  },
  title: {
    fontFamily: 'Quicksand, sans-serif',
    fontSize: '1.7rem',
    color: '#1c2434',
    fontWeight: 600,
  },
  container: {
    display: 'flex',
    alignItems: 'center',
    textAlign: 'center',
    marginBottom: '0.2rem',
  },
  paragraph: {
    fontFamily: 'Quicksand, sans-serif',
    fontWeight: 500,
    color: '#1c2434',
    fontSize: '1rem',
    lineHeight: '1rem',
  },
  text: {
    fontFamily: 'Quicksand, sans-serif',
    fontWeight: 500,
    fontSize: '1rem',
    lineHeight: '1rem',
    color: '#1c2434',
    textAlign: 'left',

    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
}));

interface Props {
  data: freightsAwaitingDriver[];
  loading: boolean;
}

const TableFreightNotAccepted: React.FC<Props> = ({ data, loading }) => {
  const [sortBy, setSortBy] = React.useState<'min' | 'max' | 'name'>('name');
  const [sortDirection, setSortDirection] = React.useState<'asc' | 'desc'>(
    'asc',
  );

  const classes = useStyles();

  const handleSortBy = (sortField: 'min' | 'max' | 'name') => {
    if (sortBy === sortField) {
      setSortDirection(prevDirection =>
        prevDirection === 'asc' ? 'desc' : 'asc',
      );
    } else {
      setSortBy(sortField);
      setSortDirection('asc');
    }
  };

  if (loading) {
    return <ActivityIndicator />;
  }

  const limitedData = data.slice(0, 5);

  const formatMinutesToHours = (
    minutes: string | number | undefined,
  ): string => {
    const numericMinutes = Number(minutes);
    if (isNaN(numericMinutes)) return 'Sem dados';

    const hrs = Math.floor(numericMinutes / 60);
    const mins = Math.floor(numericMinutes % 60);
    return `${hrs}h ${mins}m`;
  };

  return (
    <Paper className={classes.root}>
      <Typography className={classes.title}>Fretes não aceitos</Typography>
      <hr />
      <Grid container spacing={1} className={classes.container}>
        <Grid
          item
          xs={6}
          sm={6}
          md={3}
          className={classes.text}
          style={{ color: '#64748B' }}
          onClick={() => handleSortBy('name')}
        >
          Nº Carga
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={6}
          className={classes.paragraph}
          style={{ color: '#64748B' }}
          onClick={() => handleSortBy('min')}
        >
          Distribuidora
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={3}
          className={classes.paragraph}
          style={{ color: '#64748B' }}
          onClick={() => handleSortBy('max')}
        >
          Tempo de espera
        </Grid>
      </Grid>

      <hr />

      {limitedData.map((pdv, index) => (
        <React.Fragment key={index}>
          <Grid container spacing={1} className={classes.container} key={index}>
            <Grid item xs={6} sm={6} md={3} className={classes.text}>
              {pdv?.loadNumbers}
            </Grid>
            <Grid item xs={12} sm={12} md={6} className={classes.paragraph}>
              {pdv?.distributorName}
            </Grid>
            <Grid item xs={12} sm={12} md={3} className={classes.paragraph}>
              {formatMinutesToHours(pdv.minutesDiff)}
            </Grid>
          </Grid>
          <hr />
        </React.Fragment>
      ))}
    </Paper>
  );
};

export default TableFreightNotAccepted;
